import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import Vue from 'vue';
import Vuex from 'vuex';
import Meta from 'vue-meta';
import ClientOnly from 'vue-client-only';
import NoSsr from 'vue-no-ssr';
import { createRouter } from './router.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtError from '../layouts/error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData, normalizeError } from './utils';
import { createStore } from './store.js';

/* Plugins */

import nuxt_plugin_plugin_62348685 from 'nuxt_plugin_plugin_62348685'; // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_plugin_676a58ee from 'nuxt_plugin_plugin_676a58ee'; // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_appplugin_39f3bcf7 from 'nuxt_plugin_appplugin_39f3bcf7'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/app.plugin.mjs (mode: 'all')
import nuxt_plugin_configplugin_5b3c2b38 from 'nuxt_plugin_configplugin_5b3c2b38'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/config.plugin.mjs (mode: 'all')
import nuxt_plugin_nitrobridgeserver_65891e3f from 'nuxt_plugin_nitrobridgeserver_65891e3f'; // Source: ./nitro-bridge.server.mjs (mode: 'server')
import nuxt_plugin_nitrobridgeclient_14145ec7 from 'nuxt_plugin_nitrobridgeclient_14145ec7'; // Source: ./nitro-bridge.client.mjs (mode: 'client')
import nuxt_plugin_pluginutils_6d0cd680 from 'nuxt_plugin_pluginutils_6d0cd680'; // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_1331c3cb from 'nuxt_plugin_pluginrouting_1331c3cb'; // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_5ee898f8 from 'nuxt_plugin_pluginmain_5ee898f8'; // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_sentryserver_5c8df442 from 'nuxt_plugin_sentryserver_5c8df442'; // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_6bff9457 from 'nuxt_plugin_sentryclient_6bff9457'; // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_ad9eddca from 'nuxt_plugin_axios_ad9eddca'; // Source: ./axios.js (mode: 'all')
import nuxt_plugin_capiplugin_988ec7d0 from 'nuxt_plugin_capiplugin_988ec7d0'; // Source: ./capi.plugin.mjs (mode: 'all')
import nuxt_plugin_errorpluginserver_52c530de from 'nuxt_plugin_errorpluginserver_52c530de'; // Source: ../node_modules/@nuxt/bridge/dist/runtime/error.plugin.server.mjs (mode: 'server')
import nuxt_plugin_moment_e8e5b846 from 'nuxt_plugin_moment_e8e5b846'; // Source: ./moment.js (mode: 'all')
import nuxt_plugin_vueflashmessage_e0850b26 from 'nuxt_plugin_vueflashmessage_e0850b26'; // Source: ../plugins/vue-flash-message (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a'; // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a'; // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_vuexpersistedstate_1da59343 from 'nuxt_plugin_vuexpersistedstate_1da59343'; // Source: ../plugins/vuex-persistedstate (mode: 'all')
import nuxt_plugin_vuegates_72bed74b from 'nuxt_plugin_vuegates_72bed74b'; // Source: ../plugins/vue-gates (mode: 'all')
import nuxt_plugin_Axios_38ec8ac0 from 'nuxt_plugin_Axios_38ec8ac0'; // Source: ../plugins/Axios (mode: 'all')
import nuxt_plugin_jsonwebtoken_23865aa1 from 'nuxt_plugin_jsonwebtoken_23865aa1'; // Source: ../plugins/utils/jsonwebtoken (mode: 'all')
import nuxt_plugin_mock_1272001e from 'nuxt_plugin_mock_1272001e'; // Source: ../plugins/utils/mock (mode: 'all')
import nuxt_plugin_moment_3df6f394 from 'nuxt_plugin_moment_3df6f394'; // Source: ../plugins/utils/moment (mode: 'all')
import nuxt_plugin_vueapexcharts_7410a43a from 'nuxt_plugin_vueapexcharts_7410a43a'; // Source: ../plugins/vue-apexcharts.js (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4'; // Source: ../plugins/api (mode: 'all')
import nuxt_plugin_axioscredentials_24080bfd from 'nuxt_plugin_axioscredentials_24080bfd'; // Source: ../plugins/axios_credentials (mode: 'all')
import nuxt_plugin_auth_71c1ee96 from 'nuxt_plugin_auth_71c1ee96'; // Source: ./auth.js (mode: 'all')
import nuxt_plugin_AEQAuth_60d13882 from 'nuxt_plugin_AEQAuth_60d13882'; // Source: ../plugins/AEQAuth (mode: 'all')
import nuxt_plugin_removeFromState_6c2386a6 from 'nuxt_plugin_removeFromState_6c2386a6'; // Source: ../plugins/removeFromState (mode: 'all')
import nuxt_plugin_helpers_674ea771 from 'nuxt_plugin_helpers_674ea771'; // Source: ../plugins/utils/helpers (mode: 'all')
import nuxt_plugin_shared_47cc1df9 from 'nuxt_plugin_shared_47cc1df9'; // Source: ../plugins/utils/shared (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly);

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, _objectSpread(_objectSpread({}, NoSsr), {}, {
  render: function render(h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true;
      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead');
    }
    return NoSsr.render(h, ctx);
  }
}));

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild);
Vue.component('NChild', NuxtChild);

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt);
Object.defineProperty(Vue.prototype, '$nuxt', {
  get: function get() {
    var globalNuxt = this.$root ? this.$root.$options.$nuxt : null;
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt;
    }
    return globalNuxt;
  },
  configurable: true
});
Vue.use(Meta, {
  "keyName": "head",
  "attribute": "data-n-head",
  "ssrAttribute": "data-n-head-ssr",
  "tagIDKeyName": "hid"
});
var defaultTransition = {
  "name": "page",
  "mode": "out-in",
  "appear": true,
  "appearClass": "appear",
  "appearActiveClass": "appear-active",
  "appearToClass": "appear-to"
};
var originalRegisterModule = Vuex.Store.prototype.registerModule;
function registerModule(path, rawModule) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var preserveState = process.client && (Array.isArray(path) ? !!path.reduce(function (namespacedState, path) {
    return namespacedState && namespacedState[path];
  }, this.state) : path in this.state);
  return originalRegisterModule.call(this, path, rawModule, _objectSpread({
    preserveState: preserveState
  }, options));
}
function createApp(_x) {
  return _createApp.apply(this, arguments);
}
function _createApp() {
  _createApp = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(ssrContext) {
    var config,
      store,
      router,
      app,
      next,
      route,
      path,
      inject,
      _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          inject = function _inject(key, value) {
            if (!key) {
              throw new Error('inject(key, value) has no key provided');
            }
            if (value === undefined) {
              throw new Error("inject('".concat(key, "', value) has no value provided"));
            }
            key = '$' + key;
            // Add into app
            app[key] = value;
            // Add into context
            if (!app.context[key]) {
              app.context[key] = value;
            }

            // Add into store
            store[key] = app[key];

            // Check if plugin not already installed
            var installKey = '__nuxt_' + key + '_installed__';
            if (Vue[installKey]) {
              return;
            }
            Vue[installKey] = true;
            // Call Vue.use() to install the plugin into vm
            Vue.use(function () {
              if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
                Object.defineProperty(Vue.prototype, key, {
                  get: function get() {
                    return this.$root.$options[key];
                  }
                });
              }
            });
          };
          config = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          store = createStore(ssrContext);
          _context2.next = 5;
          return createRouter(ssrContext, config, {
            store: store
          });
        case 5:
          router = _context2.sent;
          // Add this.$router into store actions/mutations
          store.$router = router;

          // Create Root instance

          // here we inject the router and store to all child components,
          // making them available everywhere as `this.$router` and `this.$store`.
          app = _objectSpread({
            head: {
              "titleTemplate": "Aequivalent | %s",
              "title": "App",
              "meta": [{
                "charset": "utf-8"
              }, {
                "name": "viewport",
                "content": "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
              }, {
                "hid": "Aequivalent App",
                "name": "Aequivalent App",
                "content": "Aequivalent screening application"
              }],
              "link": [{
                "rel": "icon",
                "type": "image/x-icon",
                "href": "/favicon.ico"
              }, {
                "rel": "stylesheet",
                "type": "text/css",
                "href": "https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900&display=swap"
              }],
              "style": [],
              "script": []
            },
            store: store,
            router: router,
            nuxt: {
              defaultTransition: defaultTransition,
              transitions: [defaultTransition],
              setTransitions: function setTransitions(transitions) {
                if (!Array.isArray(transitions)) {
                  transitions = [transitions];
                }
                transitions = transitions.map(function (transition) {
                  if (!transition) {
                    transition = defaultTransition;
                  } else if (typeof transition === 'string') {
                    transition = Object.assign({}, defaultTransition, {
                      name: transition
                    });
                  } else {
                    transition = Object.assign({}, defaultTransition, transition);
                  }
                  return transition;
                });
                this.$options.nuxt.transitions = transitions;
                return transitions;
              },
              err: null,
              dateErr: null,
              error: function error(err) {
                err = err || null;
                app.context._errored = Boolean(err);
                err = err ? normalizeError(err) : null;
                var nuxt = app.nuxt; // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
                if (this) {
                  nuxt = this.nuxt || this.$options.nuxt;
                }
                nuxt.dateErr = Date.now();
                nuxt.err = err;
                // Used in src/server.js
                if (ssrContext) {
                  ssrContext.nuxt.error = err;
                }
                return err;
              }
            }
          }, App); // Make app available into store via this.app
          store.app = app;
          next = ssrContext ? ssrContext.next : function (location) {
            return app.router.push(location);
          }; // Resolve route
          if (ssrContext) {
            route = router.resolve(ssrContext.url).route;
          } else {
            path = getLocation(router.options.base, router.options.mode);
            route = router.resolve(path).route;
          }

          // Set context to app.context
          _context2.next = 13;
          return setContext(app, {
            store: store,
            route: route,
            next: next,
            error: app.nuxt.error.bind(app),
            payload: ssrContext ? ssrContext.payload : undefined,
            req: ssrContext ? ssrContext.req : undefined,
            res: ssrContext ? ssrContext.res : undefined,
            beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
            beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
            ssrContext: ssrContext
          });
        case 13:
          // Inject runtime config as $config
          inject('config', config);
          if (process.client) {
            // Replace store state before plugins execution
            if (window.__NUXT__ && window.__NUXT__.state) {
              store.replaceState(window.__NUXT__.state);
            }
          }

          // Add enablePreview(previewData = {}) in context for plugins
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              var previewData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
              app.previewData = Object.assign({}, previewData);
              inject('preview', previewData);
            };
          }
          // Plugin execution
          if (!(typeof nuxt_plugin_plugin_62348685 === 'function')) {
            _context2.next = 19;
            break;
          }
          _context2.next = 19;
          return nuxt_plugin_plugin_62348685(app.context, inject);
        case 19:
          if (!(typeof nuxt_plugin_plugin_676a58ee === 'function')) {
            _context2.next = 22;
            break;
          }
          _context2.next = 22;
          return nuxt_plugin_plugin_676a58ee(app.context, inject);
        case 22:
          if (!(typeof nuxt_plugin_appplugin_39f3bcf7 === 'function')) {
            _context2.next = 25;
            break;
          }
          _context2.next = 25;
          return nuxt_plugin_appplugin_39f3bcf7(app.context, inject);
        case 25:
          if (!(typeof nuxt_plugin_configplugin_5b3c2b38 === 'function')) {
            _context2.next = 28;
            break;
          }
          _context2.next = 28;
          return nuxt_plugin_configplugin_5b3c2b38(app.context, inject);
        case 28:
          if (!(process.server && typeof nuxt_plugin_nitrobridgeserver_65891e3f === 'function')) {
            _context2.next = 31;
            break;
          }
          _context2.next = 31;
          return nuxt_plugin_nitrobridgeserver_65891e3f(app.context, inject);
        case 31:
          if (!(process.client && typeof nuxt_plugin_nitrobridgeclient_14145ec7 === 'function')) {
            _context2.next = 34;
            break;
          }
          _context2.next = 34;
          return nuxt_plugin_nitrobridgeclient_14145ec7(app.context, inject);
        case 34:
          if (!(typeof nuxt_plugin_pluginutils_6d0cd680 === 'function')) {
            _context2.next = 37;
            break;
          }
          _context2.next = 37;
          return nuxt_plugin_pluginutils_6d0cd680(app.context, inject);
        case 37:
          if (!(typeof nuxt_plugin_pluginrouting_1331c3cb === 'function')) {
            _context2.next = 40;
            break;
          }
          _context2.next = 40;
          return nuxt_plugin_pluginrouting_1331c3cb(app.context, inject);
        case 40:
          if (!(typeof nuxt_plugin_pluginmain_5ee898f8 === 'function')) {
            _context2.next = 43;
            break;
          }
          _context2.next = 43;
          return nuxt_plugin_pluginmain_5ee898f8(app.context, inject);
        case 43:
          if (!(process.server && typeof nuxt_plugin_sentryserver_5c8df442 === 'function')) {
            _context2.next = 46;
            break;
          }
          _context2.next = 46;
          return nuxt_plugin_sentryserver_5c8df442(app.context, inject);
        case 46:
          if (!(process.client && typeof nuxt_plugin_sentryclient_6bff9457 === 'function')) {
            _context2.next = 49;
            break;
          }
          _context2.next = 49;
          return nuxt_plugin_sentryclient_6bff9457(app.context, inject);
        case 49:
          if (!(typeof nuxt_plugin_axios_ad9eddca === 'function')) {
            _context2.next = 52;
            break;
          }
          _context2.next = 52;
          return nuxt_plugin_axios_ad9eddca(app.context, inject);
        case 52:
          if (!(typeof nuxt_plugin_capiplugin_988ec7d0 === 'function')) {
            _context2.next = 55;
            break;
          }
          _context2.next = 55;
          return nuxt_plugin_capiplugin_988ec7d0(app.context, inject);
        case 55:
          if (!(process.server && typeof nuxt_plugin_errorpluginserver_52c530de === 'function')) {
            _context2.next = 58;
            break;
          }
          _context2.next = 58;
          return nuxt_plugin_errorpluginserver_52c530de(app.context, inject);
        case 58:
          if (!(typeof nuxt_plugin_moment_e8e5b846 === 'function')) {
            _context2.next = 61;
            break;
          }
          _context2.next = 61;
          return nuxt_plugin_moment_e8e5b846(app.context, inject);
        case 61:
          if (!(typeof nuxt_plugin_vueflashmessage_e0850b26 === 'function')) {
            _context2.next = 64;
            break;
          }
          _context2.next = 64;
          return nuxt_plugin_vueflashmessage_e0850b26(app.context, inject);
        case 64:
          if (!(typeof nuxt_plugin_veevalidate_6e5ad03a === 'function')) {
            _context2.next = 67;
            break;
          }
          _context2.next = 67;
          return nuxt_plugin_veevalidate_6e5ad03a(app.context, inject);
        case 67:
          if (!(typeof nuxt_plugin_i18n_1fba523a === 'function')) {
            _context2.next = 70;
            break;
          }
          _context2.next = 70;
          return nuxt_plugin_i18n_1fba523a(app.context, inject);
        case 70:
          if (!(typeof nuxt_plugin_vuexpersistedstate_1da59343 === 'function')) {
            _context2.next = 73;
            break;
          }
          _context2.next = 73;
          return nuxt_plugin_vuexpersistedstate_1da59343(app.context, inject);
        case 73:
          if (!(typeof nuxt_plugin_vuegates_72bed74b === 'function')) {
            _context2.next = 76;
            break;
          }
          _context2.next = 76;
          return nuxt_plugin_vuegates_72bed74b(app.context, inject);
        case 76:
          if (!(typeof nuxt_plugin_Axios_38ec8ac0 === 'function')) {
            _context2.next = 79;
            break;
          }
          _context2.next = 79;
          return nuxt_plugin_Axios_38ec8ac0(app.context, inject);
        case 79:
          if (!(typeof nuxt_plugin_jsonwebtoken_23865aa1 === 'function')) {
            _context2.next = 82;
            break;
          }
          _context2.next = 82;
          return nuxt_plugin_jsonwebtoken_23865aa1(app.context, inject);
        case 82:
          if (!(typeof nuxt_plugin_mock_1272001e === 'function')) {
            _context2.next = 85;
            break;
          }
          _context2.next = 85;
          return nuxt_plugin_mock_1272001e(app.context, inject);
        case 85:
          if (!(typeof nuxt_plugin_moment_3df6f394 === 'function')) {
            _context2.next = 88;
            break;
          }
          _context2.next = 88;
          return nuxt_plugin_moment_3df6f394(app.context, inject);
        case 88:
          if (!(typeof nuxt_plugin_vueapexcharts_7410a43a === 'function')) {
            _context2.next = 91;
            break;
          }
          _context2.next = 91;
          return nuxt_plugin_vueapexcharts_7410a43a(app.context, inject);
        case 91:
          if (!(typeof nuxt_plugin_api_5e4622e4 === 'function')) {
            _context2.next = 94;
            break;
          }
          _context2.next = 94;
          return nuxt_plugin_api_5e4622e4(app.context, inject);
        case 94:
          if (!(typeof nuxt_plugin_axioscredentials_24080bfd === 'function')) {
            _context2.next = 97;
            break;
          }
          _context2.next = 97;
          return nuxt_plugin_axioscredentials_24080bfd(app.context, inject);
        case 97:
          if (!(typeof nuxt_plugin_auth_71c1ee96 === 'function')) {
            _context2.next = 100;
            break;
          }
          _context2.next = 100;
          return nuxt_plugin_auth_71c1ee96(app.context, inject);
        case 100:
          if (!(typeof nuxt_plugin_AEQAuth_60d13882 === 'function')) {
            _context2.next = 103;
            break;
          }
          _context2.next = 103;
          return nuxt_plugin_AEQAuth_60d13882(app.context, inject);
        case 103:
          if (!(typeof nuxt_plugin_removeFromState_6c2386a6 === 'function')) {
            _context2.next = 106;
            break;
          }
          _context2.next = 106;
          return nuxt_plugin_removeFromState_6c2386a6(app.context, inject);
        case 106:
          if (!(typeof nuxt_plugin_helpers_674ea771 === 'function')) {
            _context2.next = 109;
            break;
          }
          _context2.next = 109;
          return nuxt_plugin_helpers_674ea771(app.context, inject);
        case 109:
          if (!(typeof nuxt_plugin_shared_47cc1df9 === 'function')) {
            _context2.next = 112;
            break;
          }
          _context2.next = 112;
          return nuxt_plugin_shared_47cc1df9(app.context, inject);
        case 112:
          // Lock enablePreview in context
          if (process.static && process.client) {
            app.context.enablePreview = function () {
              console.warn('You cannot call enablePreview() outside a plugin.');
            };
          }

          // Wait for async component to be resolved first
          _context2.next = 115;
          return new Promise(function (resolve, reject) {
            // Ignore 404s rather than blindly replacing URL in browser
            if (process.client) {
              var _router$resolve = router.resolve(app.context.route.fullPath),
                _route = _router$resolve.route;
              if (!_route.matched.length) {
                return resolve();
              }
            }
            router.replace(app.context.route.fullPath, resolve, function (err) {
              // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
              if (!err._isRouter) return reject(err);
              if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve();

              // navigated to a different route in router guard
              var unregister = router.afterEach( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from) {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (process.server && ssrContext && ssrContext.url) {
                          ssrContext.url = to.fullPath;
                        }
                        _context.next = 3;
                        return getRouteData(to);
                      case 3:
                        app.context.route = _context.sent;
                        app.context.params = to.params || {};
                        app.context.query = to.query || {};
                        unregister();
                        resolve();
                      case 8:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2, _x3) {
                  return _ref.apply(this, arguments);
                };
              }());
            });
          });
        case 115:
          return _context2.abrupt("return", {
            store: store,
            app: app,
            router: router
          });
        case 116:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _createApp.apply(this, arguments);
}
export { createApp, NuxtError };